import React from 'react';
import { FieldArray } from 'formik';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import FormHelperText from '@material-ui/core/FormHelperText';
import { FormControl } from '@material-ui/core';

import AddButton from '../../../components/buttons/add-button';
import RemoveButton from '../../../components/buttons/remove-button';

import './product-metadata.scss';

const ProductMetadataForm = (props) => {
  const {
    data, classes, onChange, errors
  } = props;
  const [dialogOpen, setDialogOpen] = React.useState(false);
  const handleDialogClose = () => {
    setDialogOpen(false);
  };
  const [indexToDelete, setIndexToDelete] = React.useState(null);

  return (
    <FieldArray
      name="metadata"
      validateOnChange={false}
      validateOnBlur={false}
      render={(arrayHelpers) => (
          <div className="product-metadata">
            <div className="product-metadata-header">
              <Typography variant="h3">Product Metadata</Typography>
              <AddButton
                label="Add Item"
                onClick={() => arrayHelpers.push({ key: '', value: '' })}
              />
            </div>
            {data && data.length > 0
              ? data.map((item, index) => {
                const _error = errors && errors[index];
                const keyError = _error && _error.key ? _error.key : null;
                const valueError = _error && _error.value ? _error.value : null;
                return (
                    <div className="metadata-row" key={index}>
                      <FormControl>
                        <TextField
                          className={`${classes.firstInput} ${classes.sectionItem}`}
                          label="Key"
                          name={`metadata.${index}.key`}
                          margin="normal"
                          onChange={onChange}
                          type="text"
                          value={item.key || ''}
                        />
                        <FormHelperText className={classes.errorText}>
                          {!item.key || item.key === '' ? keyError : null}
                        </FormHelperText>
                      </FormControl>
                      <FormControl>
                        <TextField
                          className={`${classes.textField} ${classes.sectionItem}`}
                          label="Value"
                          name={`metadata.${index}.value`}
                          margin="normal"
                          onChange={onChange}
                          type="text"
                          value={item.value || ''}
                        />
                        <FormHelperText className={classes.errorText}>
                          {!item.value || item.value === '' ? valueError : null}
                        </FormHelperText>
                      </FormControl>
                      <RemoveButton
                        style={{ paddingTop: '1.6em' }}
                        onClick={() => {
                          setDialogOpen(true);
                          setIndexToDelete(index);
                        }}
                      />
                      <Dialog open={dialogOpen} onClose={handleDialogClose}>
                        <DialogTitle id="alert-dialog-title">
                          Are you sure you want to delete this metadata?
                        </DialogTitle>
                        <DialogActions>
                          <Button onClick={handleDialogClose} color="primary">
                            Cancel
                          </Button>
                          <Button
                            onClick={() => {
                              arrayHelpers.remove(indexToDelete);
                              handleDialogClose();
                            }}
                            color="primary"
                            autoFocus
                          >
                            Confirm Delete
                          </Button>
                        </DialogActions>
                      </Dialog>
                    </div>
                );
              })
              : null}
          </div>
      )}
    />
  );
};

export default ProductMetadataForm;
